import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { BankTransactionsBulkUpdateDialogData } from '../../bank.model';
import { environment } from '../../../../environments/environment';
import { TourismEvent } from '../../../tourism-events/tourism-events.model';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, filter, map, switchMap } from 'rxjs';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

@Component({
	selector: 'app-bank-transactions-bulk-update-dialog',
	templateUrl: './bank-transactions-bulk-update-dialog.component.html',
	styleUrls: ['./bank-transactions-bulk-update-dialog.component.scss'],
})
export class BankTransactionsBulkUpdateDialogComponent implements OnInit {
	fields = {
		country: null,
		type: null,
		originalDocument: null,
		currentOwnerTransactions: null,
		comment: null,
		fvNumber: null,
		linkEvents: null,
	};

	tourismEventControl = new FormControl('');
	filteredTourismEvents: TourismEvent[] = [];

	readonly dialogRef = inject(MatDialogRef<BankTransactionsBulkUpdateDialogComponent>);
	readonly data = inject<BankTransactionsBulkUpdateDialogData>(MAT_DIALOG_DATA);
	private readonly api = inject(HttpClient);

	ngOnInit(): void {
		this.tourismEventControl.valueChanges
			.pipe(
				debounceTime(300),
				distinctUntilChanged(),
				filter((value) => typeof value === 'string' && value.length >= 3),
				switchMap((query) => this.searchTourismEvents(query)),
			)
			.subscribe((events) => {
				this.filteredTourismEvents = events;
			});
	}

	searchTourismEvents(query: string) {
		return this.api
			.get<{
				data: TourismEvent[];
			}>(`${environment.erpUrl}/tourismEvents/?request_type=autocomplete&search=${encodeURIComponent(query)}`)
			.pipe(map((response) => response.data || []));
	}

	displayTourismEventFn(event: TourismEvent | string): string {
		if (!event || typeof event === 'string') {
			return event as string;
		}
		return event.name || '';
	}

	onTourismEventSelected(event: MatAutocompleteSelectedEvent): void {
		const selectedEvent = event.option.value as TourismEvent;
		this.fields.linkEvents = selectedEvent?.id ?? null;
	}

	isFormValid(): boolean {
		return Object.values(this.fields).every((value) => value === null);
	}

	onSave(): void {
		const updatedFields = {};
		for (const key in this.fields) {
			if (this.fields[key] !== null) {
				updatedFields[key] = this.fields[key];
			}
		}

		const ids = this.data.selected.map((item) => item.positionId);

		this.api
			.patch(`${environment.erpUrl}/bankTransactions/bulk-update/`, {
				cmd: { action: 'bulk-update' },
				ids: ids,
				fields: updatedFields,
			})
			.subscribe(() => this.dialogRef.close(true));
	}

	onCancel(): void {
		this.dialogRef.close();
	}
}
